import React from 'react';
import  { useFetchShareHousePost } from '../../hooks/useFetchData';
import Detail from '../../components/shared/Detail';
import Header from '../../components/shared/Header';
import Breadcrumb from '../../components/shared/Breadcrumbs';



const ShareHouseDetailPage = () => {
  const { data: sharehouse_post, loading, error } =  useFetchShareHousePost(); 

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;
  const table_list = {
    Available: sharehouse_post.available,
    Rent: `$ ${sharehouse_post.rent} /week`,
    Bond: `$ ${sharehouse_post.bond}`,
    Notice: `${sharehouse_post.notice}weeks`,
    Minimum: `${sharehouse_post.minimum} weeks`,
    "Room type": `${sharehouse_post.room_name}`,
    Gender: `${sharehouse_post.gender_name} (${sharehouse_post.couple_name})`,
  }
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "シェアハウス一覧", path: "/sharehouse" },
    { label: `${sharehouse_post.title}`, path: "/sharehouse/:postId" },
  ];

  return (
    <div>
    <Header />
    <Breadcrumb items={breadcrumbs} />
    <Detail 
      item={sharehouse_post} 
      table_list={table_list}
      type="sharehouse"
    />
    </div>
  );
};

export default ShareHouseDetailPage;